import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import "./ReturnConfirmation.scss";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const ReturnConfirmation = () => {
  const tokena = localStorage.getItem("raer_token");
  const userId = localStorage.getItem("raer_id");

  const { id } = useParams();
  const [order, setOrder] = useState([]);

  const fetchOrder = async () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `return/getReturnOrderById/${id}`,
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        if (response?.data?.status) {
          setOrder(response.data.data);
        }
        if (response?.data?.status) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  useEffect(() => {
    fetchOrder();
  }, [id]);

  const [orderStatus, setOrderStatus] = useState();
  const orderDets = () => {
    console.log(order?.shipp_orderId);
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/ship/orderDets/${id}`,
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data?.shipments?.status);
        if (response?.data?.status) {
          setOrderStatus(response.data.data);
        }
        if (response?.data?.status) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  useEffect(() => {
    orderDets();
  }, []);

  return (
    <>
      <div>
        <div className="OC-main-div">
          <div className="OC-outer">
            <div className="OC-inner">
              <div className="section-1 row">
                <div className="sec-1-part-1 col-8">
                  {order?.orderStatus == "PROCESSING" && (
                    <h3>
                      Your order has been successfully canceled, and a refund
                      has been processed.
                    </h3>
                  )}
                </div>
              </div>
              <div className="section-2">
                <div className="sec-2-outer">
                  <p>
                    Your Return Order has been confirmed and will be taking in
                    the next 3 Days.
                  </p>
                </div>
              </div>
              <div className="section-3">
                <div className="sec-3-outer">
                  <div className="sec-3-inner">
                    <div className="head">
                      <h6>Order Details:</h6>
                    </div>
                    <div className="mid row">
                      <div className="part-1 col-6">
                        <div className="part-head">
                          <p>Order ID:</p>
                          {/* <p>Total Amount:</p> */}
                        </div>
                        <div className="part">
                          <p>{order._id}</p>
                          {/* <p>₹ {order?.total_amount}</p> */}
                        </div>
                      </div>
                      <div className="part-2 col-6">
                        <div className="part-head">
                          {/* <p>Transaction ID :</p> */}
                          <p>Date:</p>
                          {/* <p>Status:</p> */}
                        </div>
                        <div className="part">
                          {/* <p>{order?.transaction_id?._id}</p> */}
                          {/* {console.log(orderStatus?.shipments?.status)} */}
                          {/* <p>{orderStatus?.shipments?.status}</p> */}
                          <p>
                            {new Date(order?.createdAt).toLocaleDateString()}
                          </p>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div className="body">
                      <div className="body-outer">
                        {order?.products?.map((product, index) => (
                          <div key={index} className="body-inner row">
                            <div className="image-outer col-3">
                              <img
                                src={product?.productId?.image[0]}
                                alt={product?.productId?.productName}
                              />
                            </div>
                            <div className="content-outer col-3 ">
                              <div className="content">
                                <p>{product?.productId?.productName}</p>
                                <div className="but-outer">
                                  <p>Qnt:</p>
                                  <p>{product?.count}</p>
                                </div>
                              </div>
                            </div>
                            <div className="price-outer col-3">
                              <div className="price">
                                <p>
                                  Price : ₹{" "}
                                  {product?.productId?.price * product?.count}
                                </p>

                                <p>Color :{product?.productId?.color}</p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="section-4">
                <div className="sec-4-outer row">
                  <div className="part-2 col-12">
                    <div className="part-2-outer">
                      <div className="head">
                        <h6>Billing Details:</h6>
                      </div>
                      <div className="body">
                        <div className="part-1-body">
                          <p>Name:</p>
                          <p>Address:</p>
                          <p>Pin:</p>
                          <p>Contact No.:</p>
                          {/* <p>Amount:</p> */}
                        </div>
                        <div className="part-2-body">
                          <p> {order?.orderId?.billing_details?.fullName}</p>
                          <p>
                            {order?.orderId?.billing_details?.address},{" "}
                            {order?.orderId?.billing_details?.landmark},{" "}
                            {order?.orderId?.billing_details?.city},{" "}
                            {order?.orderId?.billing_details?.state}, India
                          </p>
                          <p>
                            {order?.orderId?.billing_details?.pincode ||
                              "452001"}{" "}
                          </p>
                          <p>{order?.orderId?.billing_details?.phone}</p>
                          {/* <p>₹ {order?.price}</p> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="section-5">
                <div className="button-outer">
                  <Link to={`/myAccount`}>My Orders</Link>
                </div>
              </div>
            </div>
          </div>
          <ToastContainer />
        </div>
      </div>
    </>
  );
};

export default ReturnConfirmation;
